import { createActions } from 'redux-actions';
import * as types from 'actions/areas/types';

export default createActions({}, ...Object.values(types));
